import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Line,
  Svg,
  Circle as _Circle
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(_Circle, { cx: "12", cy: "12", r: "10", stroke: `${color}` }),
        /* @__PURE__ */ jsx(_Circle, { cx: "12", cy: "12", r: "4", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Line, { x1: "4.93", x2: "9.17", y1: "4.93", y2: "9.17", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Line, { x1: "14.83", x2: "19.07", y1: "14.83", y2: "19.07", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Line, { x1: "14.83", x2: "19.07", y1: "9.17", y2: "4.93", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Line, { x1: "14.83", x2: "18.36", y1: "9.17", y2: "5.64", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Line, { x1: "4.93", x2: "9.17", y1: "19.07", y2: "14.83", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "LifeBuoy";
const LifeBuoy = memo(themed(Icon));
export {
  LifeBuoy
};
//# sourceMappingURL=life-buoy.js.map
